import { render } from "./6LinhVuc.vue?vue&type=template&id=54f2dd9d&scoped=true"
import script from "./6LinhVuc.vue?vue&type=script&scope=this%20api%20replaced%20by%20slot-scope%20in%202.5.0%2B&lang=js"
export * from "./6LinhVuc.vue?vue&type=script&scope=this%20api%20replaced%20by%20slot-scope%20in%202.5.0%2B&lang=js"

import "./6LinhVuc.vue?vue&type=style&index=0&id=54f2dd9d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f2dd9d"]])

export default __exports__